<div class="searchable-selector" [class.disabled]="disabled()" [class.open]="isOpen">
  <!-- Trigger Button -->
  <div
    class="selector-trigger"
    tabindex="0"
    (click)="toggleDropdown()"
    (keydown)="onKeyDown($event)"
    [attr.aria-expanded]="isOpen"
    [attr.aria-haspopup]="true"
    role="combobox"
  >
    <!-- Selected Value Display -->
    <div class="selected-display">
      @if (hasSelection) {
        @if (multiple()) {
          <div class="selected-chips">
            @for (option of selectedOptions.slice(0, maxDisplayItems()); track option.id) {
              <span class="selected-chip">
                @if (showIcon() && option.icon) {
                  <span class="material-symbols-outlined chip-icon">{{ option.icon }}</span>
                }
                <span class="chip-label">{{ option.label }}</span>
                <button
                  type="button"
                  class="chip-remove"
                  (click)="removeOption(option, $event)"
                  [attr.aria-label]="'Remove ' + option.label"
                >
                  <span class="material-symbols-outlined">close</span>
                </button>
              </span>
            }
            @if (selectedOptions.length > maxDisplayItems()) {
              <span class="selected-chip more-chip">
                +{{ selectedOptions.length - maxDisplayItems() }} more
              </span>
            }
          </div>
        } @else {
          <div class="single-selection">
            @if (showIcon() && selectedOption?.icon) {
              <span class="material-symbols-outlined selection-icon">{{ selectedOption?.icon }}</span>
            }
            <span class="selection-label">{{ displayValue }}</span>
          </div>
        }
      } @else {
        <span class="placeholder">{{ placeholder() }}</span>
      }
    </div>

    <!-- Actions -->
    <div class="trigger-actions">
      @if (clearable() && hasSelection && !disabled()) {
        <button
          type="button"
          class="clear-btn"
          (click)="clearSelection($event)"
          aria-label="Clear selection"
        >
          <span class="material-symbols-outlined">close</span>
        </button>
      }
      <span class="material-symbols-outlined dropdown-icon" [class.rotated]="isOpen">
        expand_more
      </span>
    </div>
  </div>

  <!-- Dropdown -->
  @if (isOpen) {
    <div
      class="dropdown-panel"
      [class.position-top]="resolvedPosition === 'top'"
      [style.top]="panelStyle.top"
      [style.left]="panelStyle.left"
      [style.width]="panelStyle.width"
      role="listbox"
    >
      <!-- Search Input -->
      @if (showSearch()) {
        <div class="search-container">
          <span class="material-symbols-outlined search-icon">search</span>
          <input
            #searchInput
            type="text"
            class="search-input"
            [placeholder]="searchPlaceholder()"
            [(ngModel)]="searchTerm"
            [ngModelOptions]="{standalone: true}"
            (ngModelChange)="onSearchChange()"
            (keydown)="onKeyDown($event)"
            autocomplete="off"
          />
          @if (searchTerm) {
            <button
              type="button"
              class="search-clear"
              (click)="searchTerm = ''; onSearchChange()"
              aria-label="Clear search"
            >
              <span class="material-symbols-outlined">close</span>
            </button>
          }
        </div>
      }

      <!-- Options List -->
      <div class="dropdown-options">
        @if (filteredOptions.length === 0) {
          <div class="empty-message">
            <span class="material-symbols-outlined">search_off</span>
            <span>{{ emptyMessage() }}</span>
          </div>
        } @else {
          @for (option of filteredOptions; track option.id; let i = $index) {
            <div
              class="option"
              [class.selected]="isSelected(option)"
              [class.disabled]="option.disabled"
              [class.highlighted]="highlightedIndex === i"
              (click)="selectOption(option)"
              role="option"
              [attr.aria-selected]="isSelected(option)"
              [attr.aria-disabled]="option.disabled"
            >
              @if (multiple()) {
                <span class="option-checkbox">
                  <span class="material-symbols-outlined">
                    {{ isSelected(option) ? 'check_box' : 'check_box_outline_blank' }}
                  </span>
                </span>
              }
              @if (showIcon() && option.icon) {
                <span class="material-symbols-outlined option-icon">{{ option.icon }}</span>
              }
              <div class="option-content">
                <span class="option-label">{{ option.label }}</span>
                @if (option.description) {
                  <span class="option-description">{{ option.description }}</span>
                }
              </div>
              @if (!multiple() && isSelected(option)) {
                <span class="material-symbols-outlined selected-check">check</span>
              }
            </div>
          }
        }
      </div>
    </div>
  }
</div>